(function () {
  'use strict';
  var config = window.athPromotionConfig || {};
  var campaign = window.athBuyMoreConfig || {};
  var COOKIE = 'ath_ad_promotion';
  var CACHE = 'athPromotionCatalogV1';
  var intent = null, catalog = null, loading = null, failedAt = 0, declined = false, invalidatedSource = null;
  var version = 0;
  function code(value) { return typeof value === 'string' ? value.trim().toUpperCase() : ''; }
  function storage(method, key, value) {
    try { return window.sessionStorage[method](key, value); } catch (e) { return null; }
  }
  function emit() { version++; document.dispatchEvent(new CustomEvent('ath:promotion-change')); }
  function cookie(value, remove) {
    var domain = /(^|\.)athsport\.co$/.test(window.location.hostname) ? '; Domain=athsport.co' : '';
    var expiry = remove ? '; Max-Age=0' : value.expiresAt ? '; Expires=' + new Date(value.expiresAt).toUTCString() : '';
    try { document.cookie = COOKIE + '=' + (remove ? '' : encodeURIComponent(JSON.stringify(value))) + '; Path=/' + domain + '; SameSite=Lax; Secure' + expiry; } catch (e) { /* In-memory intent remains usable. */ }
  }
  function clearIntent(customerRemoved, invalidated) {
    if (!intent && !catalog) return;
    intent = null; catalog = null; declined=customerRemoved === true;invalidatedSource=invalidated ? 'BLACKFRIDAYDEALS' : null;
    if (declined) cookie({code:'BLACKFRIDAYDEALS',capturedAt:Date.now(),expiresAt:null,removed:true});
    else cookie(null,true);
    storage('removeItem', CACHE); emit();
  }
  function capture(value, explicit) {
    if (declined && explicit === false) return false;
    if (code(value) !== 'BLACKFRIDAYDEALS' || config.enabled !== true) return false;
    if (!intent) { declined=false;invalidatedSource=null; intent = {code:'BLACKFRIDAYDEALS',capturedAt:Date.now(),expiresAt:null}; cookie(intent); emit(); }
    ready(); return true;
  }
  function family() {
    return campaign.enabled === true && Date.now() < Date.parse(campaign.endsAt) ? 'EBF' : '';
  }
  function validCatalog(value) {
    if (!value || value.schemaVersion !== 1 || !Array.isArray(value.offers) || value.offers.length !== 5 ||
        !isFinite(Date.parse(value.expiresAt)) || Date.parse(value.expiresAt) <= Date.now() ||
        Date.parse(value.expiresAt) > Date.now() + 60000) return false;
    var expected = ['BLACKFRIDAYDEALS'].concat([2,3,4,5].map(function(n) {return 'BUYMORE'+n+family();}));
    return expected.every(function(wanted) {return value.offers.filter(function(result) {
      if (result.code !== wanted || ['active','inactive','not_found','unsupported'].indexOf(result.state) < 0) return false;
      if (result.state !== 'active') return result.offer === null;
      var o = result.offer;
      return o && o.code === wanted && typeof o.percentage === 'number' && o.percentage >= 0 && o.percentage <= 100 &&
        o.appliesOnOneTimePurchase === true && o.appliesOnSubscription === false && Number.isSafeInteger(o.minimumQuantity) && o.minimumQuantity >= 1 &&
        isFinite(Date.parse(o.startsAt)) && (o.endsAt === null || isFinite(Date.parse(o.endsAt))) &&
        (o.itemScope === 'ALL_PRODUCTS' || (o.itemScope === 'COLLECTIONS' && Array.isArray(o.collectionIds) && o.collectionIds.length > 0 && o.collectionIds.every(function(id){return /^gid:\/\/shopify\/Collection\/\d+$/.test(id);}))) &&
        (o.minimumSubtotal === null || (o.minimumSubtotal && Number.isSafeInteger(o.minimumSubtotal.amount) && o.minimumSubtotal.amount >= 0 && /^[A-Z]{3}$/.test(o.minimumSubtotal.currency)));
    }).length === 1; });
  }
  function sourceResult() { return catalog && catalog.offers.find(function(o) {return o.code === 'BLACKFRIDAYDEALS';}); }
  function updateIntent() {
    var result = sourceResult();
    if (result && (result.state === 'inactive' || result.state === 'not_found')) { clearIntent(false,true); return false; }
    if (result && result.offer) { intent.expiresAt = result.offer.endsAt; cookie(intent); }
    return true;
  }
  function ready() {
    if (config.enabled !== true || !intent) return Promise.resolve();
    if (intent.expiresAt && Date.now() >= Date.parse(intent.expiresAt)) { clearIntent(false,true); return Promise.resolve(); }
    if (validCatalog(catalog)) return Promise.resolve();
    if (loading) return loading;
    if (failedAt && Date.now() - failedAt < 10000) return Promise.resolve();
    var controller = new AbortController();
    var timer;
    var captured = intent;
    var request = window.fetch(config.endpoint + '?codes=' + ['BLACKFRIDAYDEALS'].concat([2,3,4,5].map(function(n){return 'BUYMORE'+n+family();})).join(','), {
      mode:'cors',credentials:'omit',signal:controller.signal,cache:'no-store'
    }).then(function(response) {if (!response.ok) throw new Error('unavailable');return response.json();});
    loading = Promise.race([request,new Promise(function(_,reject) { timer=setTimeout(function(){controller.abort();reject(new Error('timeout'));},2000); })])
      .then(function(body) {
        if (intent !== captured) return;
        if (!validCatalog(body.data)) throw new Error('unsupported response');
        catalog = body.data; storage('setItem',CACHE,JSON.stringify(catalog));failedAt = 0; if (updateIntent()) emit();
      }).catch(function() {if (intent === captured) failedAt=Date.now();})
      .finally(function() {clearTimeout(timer);loading=null;});
    return loading;
  }
  function snapshot() { return {enabled:config.enabled === true,intent:intent && Object.assign({},intent),catalog:catalog && JSON.parse(JSON.stringify(catalog)),version:version,invalidatedSource:invalidatedSource}; }
  function active(o, now) { return o && now >= Date.parse(o.startsAt) && (o.endsAt === null || now < Date.parse(o.endsAt)); }
  function eligible(offer, input) {
    var quantity = Math.max(0,Math.floor(Number(input.quantity)||0));
    var subtotal = Math.max(0,Number(input.subtotal)||0);
    if (Array.isArray(input.items)) {
      quantity=0;subtotal=0;
      input.items.forEach(function(item) {
        if (item.subscription || item.selling_plan_allocation) return;
        if (offer.itemScope === 'COLLECTIONS' && (!Array.isArray(item.collectionIds) || !offer.collectionIds.some(function(id) {return item.collectionIds.indexOf(id) >= 0;}))) return;
        quantity += Math.max(0,Math.floor(Number(item.quantity)||0));
        subtotal += Math.max(0,Number(item.subtotal)||0);
      });
    } else if (offer.itemScope !== 'ALL_PRODUCTS') return null;
    if (quantity < offer.minimumQuantity || (offer.minimumSubtotal && (input.currency !== offer.minimumSubtotal.currency || subtotal < offer.minimumSubtotal.amount))) return null;
    return {offer:offer,savings:subtotal*offer.percentage/100,quantity:quantity};
  }
  function canApply(value,input) {
    if (!validCatalog(catalog)) return false;
    var result=catalog.offers.find(function(item){return item.code === code(value);});
    return !!(result && result.state === 'active' && active(result.offer,Date.now()) && eligible(result.offer,input));
  }
  function resolve(input) {
    input = input || {};
    var current = code(input.currentCode) || null;
    var base = {mode:'standard',code:null,percentage:null,nextBetterQuantity:null,nextBetterPercentage:null,savings:null};
    if (intent && intent.expiresAt && Date.now() >= Date.parse(intent.expiresAt)) clearIntent(false,true);
    if (!intent) {
      if (config.enabled !== true && current === 'BLACKFRIDAYDEALS') return Object.assign(base,{mode:'suspended',code:current});
      return base;
    }
    if (config.enabled !== true || input.blocked || input.manualCode) return Object.assign(base,{mode:'suspended',code:current});
    if (!validCatalog(catalog)) return Object.assign(base,{mode:'pending',code:current || intent.code});
    var source = sourceResult();
    if (!source || source.state === 'unsupported') return Object.assign(base,{mode:'suspended',code:current || intent.code});
    if (source.state !== 'active' || !active(source.offer, Date.now())) { clearIntent(false,true); return base; }
    var candidates = catalog.offers.filter(function(result) {return result.state === 'active' && active(result.offer, Date.now());})
      .map(function(result) {return eligible(result.offer,input);}).filter(Boolean);
    candidates.sort(function(a,b) {return b.savings-a.savings || (a.offer.code === intent.code ? -1 : b.offer.code === intent.code ? 1 : a.offer.code === current ? -1 : 1);});
    if (!candidates.length) return Object.assign(base,{mode:'campaign'});
    var best = input.confirmedOnly ? candidates.find(function(value){return value.offer.code === current;}) : candidates[0];
    if (!best) return Object.assign(base,{mode:'suspended',code:current});
    base = Object.assign(base,{mode:best.offer.code === intent.code ? 'campaign' : 'upgrade',code:best.offer.code,percentage:best.offer.percentage,savings:best.savings});
    if (input.confirmedOnly) return base;
    // A future notice is valid only if adding qualifying merchandise beats the
    // remembered offer in dollars too. Never count subscription merchandise.
    var reference = (input.items || []).find(function(item) {return !item.subscription && !item.selling_plan_allocation && Number(item.quantity)>0;});
    var unit = reference ? reference.subtotal/reference.quantity : (input.quantity ? input.subtotal/input.quantity : 0);
    for (var count = Number(input.quantity)+1; count <= Math.max(5,Number(input.quantity)+5); count++) {
      var future = Object.assign({},input,{quantity:count,subtotal:Number(input.subtotal)+(count-Number(input.quantity))*unit});
      if (reference) future.items = input.items.map(function(item) {return item === reference ? Object.assign({},item,{quantity:item.quantity+count-Number(input.quantity),subtotal:item.subtotal+(count-Number(input.quantity))*unit}) : item;});
      var baseline = eligible(best.offer,future);
      var better = catalog.offers.map(function(result){return result.state === 'active' && active(result.offer,Date.now()) && eligible(result.offer,future);}).filter(function(value){return value && baseline && value.offer.percentage > best.offer.percentage && value.savings > baseline.savings;}).sort(function(a,b){return b.savings-a.savings;})[0];
      if (better) {base.nextBetterQuantity=count;base.nextBetterPercentage=better.offer.percentage;break;}
    }
    return base;
  }
  try {
    var match = document.cookie.split(';').map(function(part){return part.trim();}).find(function(part){return part.indexOf(COOKIE+'=') === 0;});
    var saved = match && JSON.parse(decodeURIComponent(match.slice(COOKIE.length+1)));
    if (saved && saved.removed === true) declined=true;
    else if (saved && saved.code === 'BLACKFRIDAYDEALS' && typeof saved.capturedAt === 'number' && (saved.expiresAt === null || isFinite(Date.parse(saved.expiresAt)))) intent=saved;
    var cached=JSON.parse(storage('getItem',CACHE));if (validCatalog(cached)) catalog=cached;
  } catch (e) { /* Invalid cookies/cache never supply coupon amounts. */ }
  window.athPromotionPolicy = {enabled:config.enabled === true,ready:ready,snapshot:snapshot,resolve:resolve,capture:capture,clearIntent:clearIntent,canApply:canApply};
  if (config.enabled === true) {
    capture(new URLSearchParams(window.location.search).get('discount'));
    ready();
    document.addEventListener('visibilitychange',function(){if(document.visibilityState === 'visible') ready();});
    document.addEventListener('ath:cart-change',ready);
    if (window.setInterval) window.setInterval(ready,10000);
  }
})();
